import { Component, Inject } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { DialogBelonging, ToastEvokeService } from '@costlydeveloper/ngx-awesome-popup';
import { Subscription } from 'rxjs';
import { CashRegisterService } from 'src/app/services/cash-register.service';

@Component({
  selector: 'app-dialog-start-cash-register',
  templateUrl: './dialog-start-cash-register.component.html',
  styleUrls: ['./dialog-start-cash-register.component.scss']
})
export class DialogStartCashRegisterComponent {

  public cashQuantity: FormGroup;
  id_business: any;

  private subscriptions: Subscription = new Subscription();
  private data: any;


  constructor(private toastEvokeService: ToastEvokeService, private fb: FormBuilder, private cashRegisterService: CashRegisterService, private router: Router, @Inject('dialogBelonging') public dialogBelonging: DialogBelonging,) {
    this.cashQuantity = this.fb.group({
      "id_cash_register": new FormControl('', [Validators.required]),
      "initial_balance": new FormControl('', [Validators.required]),
    });
    this.id_business = localStorage.getItem('id_business');
  }
  ngOnInit(): void {
    // Check received data and other available features.
    this.data = this.dialogBelonging;

    // Subscribe to button listeners.
    this.subscriptions.add(
      // IDialogEventsController
      this.dialogBelonging.eventsController.onButtonClick$.subscribe((_Button) => {
        if (_Button.ID === 'submit') {
          this.cashQuantity.controls['id_cash_register'].setValue(this.data.customData.id_cash_register)

          if (this.cashQuantity.valid && this.cashQuantity.value.initial_balance >= 0) {
            this.cashRegisterService.startWorkTime(this.id_business, this.cashQuantity.value).subscribe(response => {
              this.dialogBelonging.eventsController.close();
              this.toastEvokeService.success('Sesión creada correctamente', 'Has inciciado sesión en la caja ' + this.data.customData.cash_name).subscribe();
              this.router.navigate(['/home']);
              localStorage.setItem('cash_register_name', this.data.customData.cash_name)
              localStorage.setItem('id_cash_register', this.data.customData.id_cash_register)
              localStorage.setItem('id_work_time', response.data.id)
              localStorage.setItem('initial_balance', response.data.initial_balance)
            })
          } else {
            this.toastEvokeService.danger('Datos incompletos', 'Introduce una cantidad inicial para abrir la caja').subscribe();
          }
        }
        else if (_Button.ID === 'cancel') {
          // Do some logic and close popup.
          this.dialogBelonging.eventsController.close();
        }
      })
    );
  }

  goBack() {
    this.dialogBelonging.eventsController.close();
  }

  ngOnDestroy(): void {
    // Care about memory and close all subscriptions.
    this.subscriptions.unsubscribe();
  }
}
